import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import QueryObjectField from './QueryObjectField';
import { FormContext } from './FormCRUD';
import { setFormValueByContext, useDialogFormSelector } from 'mrf/redux/ReduxHelper';
import { Flatten } from 'mrf/redux/Mapper';
import DialogForm from 'mrf/view/DialogForm';
import { useDispatch } from 'react-redux';
import { addResourceByIdAction } from 'mrf/redux/actions/resource';
import { useModal } from './Modal';
import { deleteFormAction } from 'mrf/redux/actions/form';

FormQueryObjectField.propTypes = {
    context: PropTypes.object,
    field: PropTypes.string.isRequired, // Field name.
    title: PropTypes.string,
    method: PropTypes.string, // Either POST or PUT.
    descriptor: PropTypes.object,
    formEndpoint: PropTypes.string.isRequired, // The endpoint to save the object.
    getEndpoint: PropTypes.string, // The endpoint to fetch the saved object.
    resource: PropTypes.string.isRequired, // Resource name to save/retrieve data on redux.
    initForm: PropTypes.func, // Function that initializes the subform.
}

export default function FormQueryObjectField({
    context,
    field,
    formEndpoint,
    getEndpoint,
    resource,
    initForm,
    title = `Add new ${resource}`,
    descriptor,
    method = 'POST',
    children,
    disableAdd = false,
    disableRemove=false,
    ...props
}) {
    const dispatch = useDispatch();

    const formContext = useContext(FormContext);
    if (!context) {
        context = formContext;
    }

    const dialogQueryObjectField = useModal();

    const dialogFormContext = useDialogFormSelector({ resource, initForm });

    useEffect(() => {
        if (!dialogFormContext.isOpen) {
            dispatch(deleteFormAction(resource));
        }
    }, [ dialogFormContext.isOpen ]); // eslint-disable-line

    const handleSubmit = ret => {
        if (!ret) {
            console.error(`The endpoint (${method}: ${formEndpoint}) did not return anything!`);
            return;
        }

        dispatch(addResourceByIdAction(resource, [ Flatten(dispatch, ret, descriptor) ]));
        setFormValueByContext(dispatch, context, { [field]: ret.id });

        dialogQueryObjectField.close();
    }

    return <>
        <QueryObjectField
            context={context}
            field={field}
            resource={resource}
            descriptor={descriptor}
            dialog={dialogQueryObjectField}
            addCb={!disableAdd && dialogFormContext.open}
            disableAdd={disableAdd}
            disableRemove={disableRemove}
            {...props}
        />
        <DialogForm
            title={title}
            context={dialogFormContext}
            submitCb={handleSubmit}
            endpoint={formEndpoint}
            getEndpoint={getEndpoint}
            method={method}
        >
            {children}
        </DialogForm>
    </>
}
